import _debounce from 'lodash/debounce';

import { KICKED_OUT } from '../../../react/features/base/conference/actionTypes';
import {
    leaveConference
} from '../../../react/features/base/conference/actions';
import { JitsiConferenceEvents } from '../../../react/features/base/lib-jitsi-meet';
import { MEDIA_TYPE } from '../../../react/features/base/media/constants';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import {
    isLocalTrackMuted
} from '../../../react/features/base/tracks/functions.any';
import {
    setRequestingSubtitles
} from '../../../react/features/subtitles/actions.any';
import { muteLocal } from '../../../react/features/video-menu/actions.any';
import { iAmVisitor } from '../../../react/features/visitors/functions';
import { updateLang } from '../../../x-bees/components/conference/actions.any';
import {
    isMetaWildixTranscriptionDisabled
} from '../../../x-bees/components/transcribing/actions.any';
import { isTranscriptionOff } from '../../../x-bees/components/transcribing/functions';
import { showDialogReJoin } from '../../functions.any';
import { getAlert, setAlert } from '../../native/components/alert';
import WildixXMPPEvents from '../../service/xmpp/WildixXMPPEvents';
import { LOGOUT_FROM_WIZYCONF_ROOM } from '../../wizyconf/constants';
import { selectedLangTranscription, toggleVisitorMuteButton } from '../customStorageSettings/actions';


/**
 * Listens when the conference state available.
 */
StateListenerRegistry.register(
    state => state['features/base/conference'].conference,
    /* listener */ (conference, { dispatch, getState }) => {
        if (!conference) {
            return;
        }
        const state = getState();
        const { visitorMute, langTranscription } = state['wildix/customStorageSettings'];
        const audioMuted = isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.AUDIO);

        if (visitorMute && !iAmVisitor(state) && audioMuted) {
            dispatch(muteLocal(false, MEDIA_TYPE.AUDIO));
            dispatch(toggleVisitorMuteButton(false));
        }

        conference.on(JitsiConferenceEvents.KICKED, participant => {
            // If user kicked in different platforms
            if (navigator.product === 'ReactNative') {
                dispatch(setAlert(getAlert('', KICKED_OUT, participant)));
            } else if (APP.wildix.wizy) {
                window.postMessage(LOGOUT_FROM_WIZYCONF_ROOM, '*');
            } else {
                showDialogReJoin();
                dispatch(leaveConference());
            }
        });

        // Listeners for Transcription
        conference?.room?.addEventListener(WildixXMPPEvents.TRANSCRIPTION_LANGUAGE, _debounce((lang, id) => {
            const { transcriptionLanguageCopied } = getState()['wildix/features/transcribing'];
            const langSelected = `translation-languages:${lang}`;

            if (!lang || transcriptionLanguageCopied === langSelected
                || isMetaWildixTranscriptionDisabled(getState())) {
                return;
            }
            if (iAmVisitor(getState())) {
                // Disable label transcription for visitors
                // const [ firstCodeLang ] = lang?.split('-') ?? [ 'en-US' ];
                // dispatch(transcriptionLanguagesCopied(langSelected, firstCodeLang.toUpperCase()));
                return;
            }

            if (id !== conference.myUserId()) {
                if (!isTranscriptionOff(state)) {
                    dispatch(updateLang(`translation-languages:${lang}`));
                } else {
                    dispatch(setRequestingSubtitles(true, true, `translation-languages:${lang}`));
                }
            }
        }, 1000));


        // TODO remove later this code
        if (langTranscription === 'undefined') {
            dispatch(selectedLangTranscription('en-US'));
        }

        // END listeners for Transcription
    }
);
